export default __webpack_public_path__ + "static/media/DOS-2.75caee2d.jpg";